<template>
    <div class="table-head head-fixed">
        <div class="table-tr">
            <div class="table-th cell-length">{{ __('Patient') }}</div>
            <div class="table-th cell-activity">{{ __('Latest activity') }}</div>
            <div class="table-th">{{ __('Badge') }}</div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'

export default {
    extends: TableHeader
}
</script>
